import type { ShiftWithSlots } from '../shifts/types'

import type { SupporterOption } from './types'

export const assignedSupporters = (shifts: ShiftWithSlots[]): SupporterOption[] => {
  const byId = new Map<string, SupporterOption>()

  for (const shift of shifts) {
    for (const slot of shift.shiftSlots.nodes) {
      if (slot.supporter && !byId.has(slot.supporter.id)) {
        byId.set(slot.supporter.id, { id: slot.supporter.id, fullName: slot.supporter.fullName ?? '' })
      }
    }
  }

  return Array.from(byId.values()).sort((a, b) => a.fullName.localeCompare(b.fullName))
}
